<div class="dialog-main-container">
    <div class="dialog-image-container">
        <div class="exit-icon"
            *ngIf="action==='exit'"></div>
        <div class="finish-icon"
            *ngIf="action==='finish'"></div>
        <div class="dfos-icon"
            *ngIf="action==='dfos'"></div>
        <div class="reconfigure-icon"
            *ngIf="action==='reconfigure'"></div>
        <div class="configure-icon"
            *ngIf="action==='lineConfig'"></div>
    </div>

    <div class="dialog-bold-text-container">
        <span class="dialog-bold-text"
            *ngIf="action==='exit'">
            {{'config_exception.heading_exit' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='finish'">
            {{'config_exception.heading_finish' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='dfos'">
            {{'config_exception.heading_dfos' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='reconfigure'">
            {{'config_exception.heading_reconfig' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='lineConfig'">
            {{'config_exception.heading_line' | translate}}
        </span>
    </div>

    <div class="dialog-small-text-container">
        <span class="dialog-bold-text"
            *ngIf="action==='exit'">
            {{'config_exception.desc_exit' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='finish'">
            {{'config_exception.desc_finish' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='dfos'">
            {{'config_exception.desc_dfos' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='reconfigure'">
            {{'config_exception.desc_reconfig' | translate}}
        </span>
        <span class="dialog-bold-text"
            *ngIf="action==='lineConfig'">
            {{'config_exception.desc_line' | translate}}
        </span>
    </div>

    <div class="dialog-warning-text-container">
        <span class="dialog-warning-text"
            *ngIf="action==='exit'">
            {{'config_exception.confirmation_exit' | translate}}?
        </span>
        <span class="dialog-warning-text"
            *ngIf="action==='reconfigure'">
            {{'config_exception.confirmation_reconfig' | translate}}?
        </span>
        <span class="dialog-warning-text"
            *ngIf="action==='lineConfig'">
            {{'config_exception.confirmation_line' | translate}}?
        </span>
    </div>

    <div class="btn-container">
        <button mat-button
            *ngIf="action!=='finish'"
            class="cancel-btn"
            (click)="close_dialogue('cancelled')">{{'common.cancel' | translate}}
        </button>

        <button mat-flat-button
            class="exit-btn"
            (click)="close_dialogue('exit')">{{btnName | translate}}
        </button>
    </div>

    <div class="dialog-dfos-mail-container"
        *ngIf="action==='dfos'">
        <div class="dialog-dfos-text">
            {{'config_exception.email_desc' | translate}}
        </div>
        <div class="dialog-dfos-mail">
            andrei.bulgaru@unilever.com
        </div>
    </div>
</div>